import React, {useRef, useState} from 'react';
import Button from '../button';
import moment from 'moment';

import './index.scss';

export function EditRequestsFormInternal ({onCancel, onInternalMessageSubmit, internalMessages}) {

    const [formValue, setFormValue] = useState({
        editRequest: '',
    });

    const messagesEndRef = useRef(null);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }

    function onChangeHandler(e) {
        setFormValue({...formValue, [e.target.name]: e.target.value});
    }

    async function onRequestSubmitHandler() {
        if(!formValue?.editRequest) return;
        await onInternalMessageSubmit(formValue.editRequest);
        setFormValue({editRequest: ''});
        scrollToBottom();
    }

    return (
        <div className={'edits-form'}>
            <div className={'edits-form__header internal-form'}>
                <div className={'header-title'}>
                    <span>{'Internal Comments'}</span>
                </div>
            </div>
            <div className={'edits-form__body'}>
                <div className={'comments-wrapper'}>
                    {internalMessages?.map((iM, index) => {
                        return  <div className={'comment-row'} key={index}>
                            <div className={'comment-info'}>
                                <span>{iM.emailAddress}</span>
                                <span>{moment(iM.createdAt).format("MM/DD/YY hh:mm-ss")}</span>
                            </div>
                            <div className={'comment-text'}>{iM.message}</div>
                        </div>
                    })}
                    <div ref={messagesEndRef} />
                </div>
                {onInternalMessageSubmit &&
                    <>
                        <div className={'edits-form__input-wrapper'}>
                            <label className={'edits-form__label'}>
                                {'Enter internal feedback on content before compiling and sharing to creator in Final Feedback'}
                            </label>
                            <textarea className={'edits-form__text-area edits-form__input-text'}
                                      name={'editRequest'}
                                      value={formValue.editRequest}
                                      onChange={onChangeHandler}/>
                        </div>
                        <div className={'edits-form__buttons-wrapper'}>
                            <Button bigtext ghost notransform bold
                                    onClick={() => {
                                        setFormValue({editRequest: ''});
                                        onCancel();
                                    }}>
                                {'Cancel'}
                            </Button>
                            <Button notransform bigtext bold
                                    disabled={!formValue.editRequest}
                                    onClick={onRequestSubmitHandler}>
                                {'Submit Internal Comments'}
                            </Button>
                        </div>
                    </>
                }
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./components/edit_requests_form_internal/index.js